class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.megaContent = this.querySelector('.mega-menu__content');
    this.megaRight = this.querySelector('.mega-menu__right');
    if (this.megaContent && this.megaRight) {
      this.bindMegaMenu();
    }
  }

  bindMegaMenu() {
    const leftItems = this.megaContent.querySelectorAll('.mega-menu__left-item');
    leftItems.forEach((item) => {
      item.addEventListener('click', (e) => {
        const index = item.getAttribute('data-index');
        if (index !== null) {
          this.megaContent.setAttribute('data-visible-panel', index);
          leftItems.forEach((el) => {
            el.removeAttribute('data-selected');
            el.setAttribute('aria-expanded', 'false');
          });
          item.setAttribute('data-selected', 'true');
          item.setAttribute('aria-expanded', 'true');
        }
        if (item.tagName !== 'A') {
          e.preventDefault();
        }
      });
      item.addEventListener('mouseenter', () => {
        const index = item.getAttribute('data-index');
        if (index === null) return;
        this.megaContent.setAttribute('data-visible-panel', index);
      });
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.megaContent && this.mainDetailsToggle.open) {
      const defaultPanel = this.megaContent.querySelector('.mega-menu__right-panel[data-default="true"]');
      if (defaultPanel) {
        this.megaContent.setAttribute('data-visible-panel', defaultPanel.getAttribute('data-index'));
      }
    }

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
